/** DEMO ONLY — persistent banner. */
import React from "react";
import { Box } from "@mui/material";

export default function DemoRibbon() {
  return (
    <Box
      sx={{
        backgroundColor: "#512879",
        color: "#fff",
        px: 2,
        py: 0.75,
        fontSize: 13,
        fontWeight: 600,
        letterSpacing: 0.3,
        textAlign: "center",
      }}
    >
      DEMO — mock data, nothing is saved to the live system. Concept preview of
      dynamic pricing slabs.
    </Box>
  );
}
